export default "__VITE_ASSET__DAsKZx6S__"